import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
      <div class="poem">
        <p class="poem-block mb-3">
          От туч тяжело-серых,<br/>
          От ветра, что вчера еще и грел нас, и ласкал,<br/>
          Сегодня ж из его объятий охладелых<br/>
          Мы выскользнуть хотим, как из руки – бокал;
        </p>

        <p class="poem-block mb-3">
          В предчувствии зимы,<br/>
          Когда сжимает душу<br/>
          Прохладных вечеров густая синева,<br/>
          И шум горячих дней становится все глуше,<br/>
          И все слышней<br/>
          Ночами свист ветвей –<br/>
          На языке зимы знакомые слова;
        </p>

        <p class="poem-block mb-3">
          В предчувствии зимы –<br/>
          Пока нам солнце светит,<br/>
          Пока мы можем и дышать, и петь –<br/>
          Мы будем петь о солнце и о свете.<br/>
          И так мы встретим смерть.
        </p>
      </div>
    `
  )
}

const itemName = {
  rus: 'В предчувствии зимы'
}
const itemDate = {
  rus: '17 мая 1998'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;